import {
	TGetForeignDefaultInfoUnitResponse,
	TGetForeignDomesticUnitListResponse,
} from '@/services';
import { formatDate } from '@/utils';

export const formatForeignDefaultInfoUnitDetail = (
	input: TGetForeignDefaultInfoUnitResponse
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatForeignDomesticUnitList = (
	input: TGetForeignDomesticUnitListResponse['content']
) => {
	return input.map((item) => ({
		id: item.id,
		label: item.name,
		value: item.id,
	}));
};
